function SeperatePhoneNum(phone) {
  
  const f = phone.substring(0, 3);
  const s = phone.substring(3, 7);
  const t = phone.substring(7, 11);

  return `${f}-${s}-${t}`;
}

export default SeperatePhoneNum;